export default {"src":"https://appsumo2next-cdn.appsumo.com/_next/static/media/appsumo-plus-bg-white.e7bbacf0.svg","height":33,"width":55};